import React from 'react';
import { useSlideData } from '@context/slide-data';
import { SectionOne } from './SectionOne';
import { SectionTwo } from './SectionTwo';

export const TermOptionsScript = () => {
    const { slideState, data } = useSlideData();
    const { id, details: termOptions } = data;
    const { selectedTerm, selectedSection } = slideState;
    const termData = termOptions[selectedTerm[id]];

    const sections = {
        1: <SectionOne termData={termData} />,
        2: <SectionTwo termData={termData} />
    };

    return sections[selectedSection[id]];
};

export default TermOptionsScript;
